var document = require('./_global').document;
module.exports = document && document.documentElement;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_html.js
 ** module id = 262
 ** module chunks = 19
 **/